import { useEffect, useState } from "react";

export const useIsAgentThinking = (agentState: string): boolean => {
  const [isThinking, setIsThinking] = useState(false);
  useEffect(() => {
    if (agentState === "thinking") {
      setIsThinking(true);
    } else if (agentState !== "listening" && isThinking) {
      setIsThinking(false);
    }
  }, [agentState]);

  return isThinking;
};
